import IdentityVerification from "../../Visitor/SubComponents/IdentityVerification";
import React from "react";
import {IdentityVerificationApp} from "../Functionality/IdentityVerificationApp";
import UpdateIdentityValidationModal from "../../Visitor/Modal/UpdateIdentityValidationModal";
import HeadTittle from "../../../../../components/HeadTittle";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {DownloadIcon} from "../../../../../components/buttons/IconButtons";
import {CommonIdentityVerificationApp} from "../Functionality/CommonIdentityVerificationApp";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const InvitationIdentity = () => {
    const {
        userId,
        invitationId,
        userTypeId,
        setShowApprove,
        setShowDenied,
        genericCommentModals,
        handleOnBack
    } =  IdentityVerificationApp()

    const {
        item,
        disabled,
        identityDocuments,
        identityValidationType,
        identityValidationStatus,
        setModified,
        modified,
        handleDownload,
        hasIdentityFiles,
        canValidate
    } = CommonIdentityVerificationApp({
        userId,
        invitationId,
        userTypeId
    });

    return (
        <>
            <HeadTittle name={'identity_validation'} onBack={handleOnBack}>
                {item && (
                    <ButtonAction
                        id='btn_ii_download'
                        name='download'
                        className='btn-icon-export'
                        disabled={!hasIdentityFiles}
                        Icon={DownloadIcon}
                        onClick={handleDownload}
                    />
                )}
            </HeadTittle>
            {identityDocuments && <div className={"ml-15 mr-15"}>
                <IdentityVerification
                    item={item}
                    setShowApproveModal={setShowApprove}
                    setShowDeniedModal={setShowDenied}
                    disabled={disabled || !canValidate}
                    identityDocuments={identityDocuments}
                    identityValidationType={identityValidationType}
                    identityValidationStatus={identityValidationStatus}
                    invitationId={invitationId}
                    userTypeId={userTypeId}
                />
            </div>
            }
            {genericCommentModals.map((props) => {
                    const { show, setter} = props
                    return (
                        <>
                            <UpdateIdentityValidationModal
                                invitationId={invitationId}
                                show={show}
                                onHide={() => setter(false)}
                                setModified={setModified}
                                modified={modified}
                                userId={userId}
                                {...props}
                            />
                        </>
                    )
                }
            )}
        </>
    )
}

export default InvitationIdentity
